module.exports = __webpack_public_path__ + "static/media/document-minus.dc978246.svg";